import {insert} from 'ramda';

import {PriceMapCarResponseBody, SourcingVehicleResponseBody} from '@dms/api/core';

import {CarOrMyVehicle} from '../types/CarOrMyVehicle';

export function addMyVehicleToAllCars(
  cars: PriceMapCarResponseBody[],
  myVehicle: SourcingVehicleResponseBody,
  queryPricePosition: number
): CarOrMyVehicle[] {
  return insert<CarOrMyVehicle>(
    queryPricePosition,
    {
      ad_id: 'my-vehicle',
      days_on_stock: myVehicle.daysOnStock ?? null,
      feature_score: myVehicle.featureScore ?? null,
      first_scraped_price_currency: myVehicle.price?.currency?.key ?? null,
      first_scraped_price_with_vat: myVehicle.price?.withVat ?? null,
      is_available: true,
      is_sold: false,
      last_occurrence: myVehicle.occurrence?.last ?? null,
      location: null,
      mileage: myVehicle.mileage ?? 0,
      original_currency: myVehicle.price?.currency?.key ?? null,
      original_price_with_vat: myVehicle.price?.withVat ?? null,
      price_with_vat: myVehicle.extraData?.predictedPrice ?? null,
      suspicious: myVehicle.suspicious ?? null,
      isMyVehicle: true,
    },
    cars.map((car) => ({...car, isMyVehicle: false}))
  );
}
